import { Component, inject } from '@angular/core';
import { ProjectsFormComponent } from './projects-form/projects-form.component';
import { createProject } from '../../../store/actions/projects.actions';
import { Store } from '@ngrx/store';
import { ProjectsTableComponent } from './projects-table/projects-table.component';

@Component({
  selector: 'app-manage-projects',
  imports: [ProjectsFormComponent, ProjectsTableComponent],
  templateUrl: './manage-projects.component.html',
  styleUrl: './manage-projects.component.scss'
})
export class ManageProjectsComponent {
  private store = inject(Store);
  onCreate(formData: any): void {

    this.store.dispatch(createProject({ project: formData }));
  }
}
